module.exports = __webpack_public_path__ + "img/your_nouiki.19a789af.jpg";